var _g;
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Dots = function Dots(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size * 0.27,
    viewBox: "0 0 22 6",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: /*#__PURE__*/_jsx("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        id: "PC-1366-Copy-3",
        transform: "translate(-1212.000000, -625.000000)",
        fill: !ignoreColor ? color : undefined,
        fillRule: "nonzero",
        children: _g || (_g = /*#__PURE__*/_jsxs("g", {
          id: "Group-Copy-5",
          transform: "translate(1212.000000, 625.000000)",
          children: [/*#__PURE__*/_jsx("circle", {
            id: "Oval",
            cx: "3",
            cy: "3",
            r: "3"
          }), /*#__PURE__*/_jsx("circle", {
            id: "Oval-Copy",
            cx: "11",
            cy: "3",
            r: "3"
          }), /*#__PURE__*/_jsx("circle", {
            id: "Oval-Copy-2",
            cx: "19",
            cy: "3",
            r: "3"
          })]
        }))
      })
    })
  });
};
export default Dots;